import type { PayViaLinkDetailsModel } from '../../domain/models/payment.types';

export interface PayViaLinkDetailsAppVm {
  paymentSource?: string;
  amount: number;
  currency: string;
  orderId: string;
  txnId?: string;
  merchantName: string;
  totalItems: number;
  savings: number;
  razorpayKeyId: string;
  razorpayCustomerId?: string;
  isBankOfferSelected: boolean;
  expiresAt?: number;
}

export function toPayViaLinkDetailsAppVm(
  details: PayViaLinkDetailsModel
): PayViaLinkDetailsAppVm {
  const expiresAt = details.expiresAt || details.paymentDetails?.expiresAt;

  return {
    paymentSource: details.source,
    amount: details.amount,
    currency: details.currency,
    orderId: details.orderId,
    txnId: details.txnId,
    merchantName: details.merchantName,
    totalItems: details.totalItems,
    savings: details.savings,
    razorpayKeyId: details.razorpayKeyId || details.key,
    razorpayCustomerId: details.razorpayCustomerId,
    isBankOfferSelected: details.isBankOfferSelected,
    expiresAt,
  };
}
